import React, { useEffect } from 'react';
import { Card } from 'primereact/card';
import { Tag } from 'primereact/tag';
import { Message } from 'primereact/message';
import { Accordion, AccordionTab } from 'primereact/accordion';
import UserManagement from '../components/UserManagement';

const AdminUsers = () => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const userRoles = JSON.parse(localStorage.getItem('userRoles') || '[]');
    const primaryRole = userRoles.length > 0 ? userRoles[0] : (user.user_type || 'user');

    // Only tenant_admin can access user management
    const isTenantAdmin = primaryRole === 'tenant_admin';
    const isImpersonating = localStorage.getItem('isImpersonating') === 'true';

    useEffect(() => {
        document.title = 'User Management - interestng';
    }, []);

    // Check if user is tenant_admin OR if we're impersonating (admin is in background)
    if (!isTenantAdmin && !isImpersonating) {
        return (
            <div className="grid">
                <div className="col-12">
                    <Card title="Access Denied">
                        <Message
                            severity="error"
                            text="You need admin privileges to access this page."
                        />
                    </Card>
                </div>
            </div>
        );
    }

    return (
        <div className="grid">
            <div className="col-12">
                {/* Page header — stacks on mobile, side-by-side from md */}
                <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-3 mb-4">
                    <div>
                        <h1 className="text-xl font-semibold text-900 m-0 mb-1">User Management</h1>
                        <p className="text-600 text-sm m-0">
                            Manage users and view applications from their perspective
                        </p>
                    </div>
                    <div className="flex flex-wrap align-items-center gap-2">
                        <Tag
                            value="Tenant Admin View"
                            severity="info"
                            icon="pi pi-shield"
                        />
                        <Tag
                            value={`Tenant: ${user.tenant_id || 'Unknown'}`}
                            severity="secondary"
                            icon="pi pi-building"
                        />
                    </div>
                </div>

                {/* Collapsible instructions — helpful, but out of the way by default */}
                <Accordion className="mb-3">
                    <AccordionTab
                        header={
                            <span className="flex align-items-center gap-2 text-sm font-medium">
                                <i className="pi pi-info-circle text-primary" />
                                How to Use User Management
                            </span>
                        }
                    >
                        <div className="grid">
                            <div className="col-12 md:col-4">
                                <div className="flex align-items-center gap-2 mb-2">
                                    <i className="pi pi-user text-primary" />
                                    <span className="font-medium text-sm">Step 1: Select User</span>
                                </div>
                                <p className="text-600 text-sm m-0">
                                    Find the user you want to view as in the table below and click "View User".
                                </p>
                            </div>
                            <div className="col-12 md:col-4">
                                <div className="flex align-items-center gap-2 mb-2">
                                    <i className="pi pi-eye text-primary" />
                                    <span className="font-medium text-sm">Step 2: User Perspective</span>
                                </div>
                                <p className="text-600 text-sm m-0">
                                    You'll see the application exactly as that user sees it, with their permissions and data.
                                </p>
                            </div>
                            <div className="col-12 md:col-4">
                                <div className="flex align-items-center gap-2 mb-2">
                                    <i className="pi pi-arrow-left text-primary" />
                                    <span className="font-medium text-sm">Step 3: Switch Back</span>
                                </div>
                                <p className="text-600 text-sm m-0">
                                    Click "Switch Back to Admin" in the banner to return to your admin view.
                                </p>
                            </div>
                        </div>
                    </AccordionTab>
                </Accordion>

                {/* User Management Component */}
                <UserManagement />
            </div>
        </div>
    );
};

export default AdminUsers;
